// extracted by mini-css-extract-plugin
export default {"main":"d5b0b84a69","tit":"ec89294fe4","maintitle":"_08e251cb75","ylw":"abe39587ee","white":"_0eb37ac8e6","mv_title":"_5a2130b27e","mv_nc":"_62189ead72","mv_in":"e07e52de12"};